import { render, staticRenderFns } from "./ItemWriteLink.vue?vue&type=template&id=4fd67dc3&scoped=true"
import script from "./ItemWriteLink.vue?vue&type=script&lang=js"
export * from "./ItemWriteLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd67dc3",
  null
  
)

export default component.exports